module.exports = __webpack_public_path__ + "img/logo.8b6edbb6.jpg";